Whether the event was successfully delivered via the specified webhook `subscriptionId`.

This filter does not apply if `subscriptionId` is not specified.
